module.exports = __webpack_public_path__ + "img/welcome.5c88aeff.webp";